import { PageTabs, PageTabsContent, PageTabsList, PageTabsTrigger } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PageTabsHeader } from "../../../components";
import { TwilioPhoneNumbers } from "@tellescope/onboarding";
import { TwilioUsageChart } from "./TwilioUsageChart";
import { PhoneLogsTable } from "./PhoneLogsTable";
import { usePhoneLogsDefaultViewShallowStore } from "../../../store";

export interface PhoneSettingsPageProps {
  selectedTab: "numbers" | "usage" | "logs";
}

export const PhoneSettingsPage = ({ selectedTab }: PhoneSettingsPageProps) => {
  const { t } = useTranslation("settings");
  const { lastSelectedViewId } = usePhoneLogsDefaultViewShallowStore("lastSelectedViewId");

  return (
    <PageTabs defaultValue={selectedTab} value={selectedTab} className="flex flex-col flex-1 min-h-0 overflow-hidden">
      <PageTabsHeader>
        <PageTabsList>
          <PageTabsTrigger asChild value="numbers">
            <Link to="/settings/phone/numbers">{t("Phone Numbers")}</Link>
          </PageTabsTrigger>
          <PageTabsTrigger asChild value="usage">
            <Link to="/settings/phone/usage">{t("Usage & Billing")}</Link>
          </PageTabsTrigger>
          <PageTabsTrigger asChild value="logs">
            <Link to={`/settings/phone/logs/views/${lastSelectedViewId || "all"}`}>{t("Logs")}</Link>
          </PageTabsTrigger>
        </PageTabsList>
      </PageTabsHeader>
      <PageTabsContent value="numbers" className="data-[state=active]:flex flex-col flex-1 min-h-0 overflow-hidden">
        <section className="border-b px-6 py-4 space-y-2">
          <h1 className="text-3xl leading-9 text-gray-950 font-semibold">{t("Phone Numbers")}</h1>
          <h4 className="text-muted-foreground">{t("Configure phone and calling preferences")}</h4>
        </section>
        <TwilioPhoneNumbers className="px-6 flex-1 min-h-0" />
      </PageTabsContent>
      <PageTabsContent value="usage" className="data-[state=active]:flex flex-col flex-1 min-h-0 overflow-hidden">
        <section className="border-b px-6 py-4 space-y-2">
          <h1 className="text-3xl leading-9 text-gray-950 font-semibold">{t("Usage and Billing")}</h1>
          <h4 className="text-muted-foreground">
            {t("Monitor usage and billing information for Twilio voice and text")}
          </h4>
        </section>
        <TwilioUsageChart />
      </PageTabsContent>
      <PageTabsContent value="logs" className="data-[state=active]:flex flex-col flex-1 min-h-0 overflow-hidden">
        <section className="border-b px-6 py-4 space-y-2">
          <h1 className="text-3xl leading-9 text-gray-950 font-semibold">{t("Logs")}</h1>
          <h4 className="text-muted-foreground">{t("View commmunication logs")}</h4>
        </section>
        <PhoneLogsTable />
      </PageTabsContent>
    </PageTabs>
  );
};
